import { Component, Input, Output, EventEmitter } from "@angular/core"

@Component({
  selector: "events-list",
  templateUrl: "index.html",
})
export class EventsList {

  @Input() events: any = []
  @Output() statusChanged = new EventEmitter()

  onStatusChanged(event) {

    this.statusChanged.emit(event)
  }
}



// WEBPACK FOOTER //
// ./src/components/events-list/index.ts